// extracted by mini-css-extract-plugin
module.exports = {"truck-badge":"TruckBadge_truck-badge__24hij","active":"TruckBadge_active__xR7UW","icon":"TruckBadge_icon__12AkN"};